import Vue from "vue";
import Router from "vue-router";
import * as VueGoogleMaps from "vue2-google-maps";
import Inicio from "@/pages/Inicio";
import FichaEstablecimiento from "@/pages/FichaEstablecimiento";

Vue.use(Router);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCc2X1aM4VSRTTSPgmMP_E5fcCEqTxe22c",
    libraries: "places,drawing,visualization",
    region: "CL",
    language: "es-419"
  }
});

const router = new Router({
  base: CONTEXT,
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Inicio",
      component: Inicio
    },
    {
      path: "/establecimiento/:rbd",
      name: "FichaEstablecimiento",
      component: FichaEstablecimiento
    },
    {
      path: "*",
      name: "RerouteInicio",
      component: Inicio
    },
    {
      path: "/registro",
      name: "Registro",
      beforeEnter() {
        location.href = PLATAFORMA.REGISTRO;
      }
    },
    {
      path: "/login",
      name: "Login",
      beforeEnter() {
        location.href = PLATAFORMA.LOGIN;
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js